import { QuoteBindingSearchRequestQuery } from '@lio/api-types';

export const quoteBindingQueryKey = {
  resource: 'quoteBinding' as const,
  get: (quoteId?: string) => [quoteBindingQueryKey.resource, quoteId] as const,
  getWithParams: (quoteId?: string, id?: string) => [...quoteBindingQueryKey.get(quoteId), 'binding', id] as const,
  searchWithParams: (quoteId?: string, params?: QuoteBindingSearchRequestQuery) =>
    [...quoteBindingQueryKey.get(quoteId), params] as const,
};
